import * as React from "react";
import { Box } from "@mui/material";
import { capitalizeWords } from "../../../../utils/storage";

interface PriceSectionProps {
  productName?: string;
  regularPriceNumber: number;
  salePriceNumber: number;
  hasPrice: boolean;
  hasSale: boolean;
  formatMoneyData: (amount: number) => string;
}

const PriceSection = ({
  productName,
  regularPriceNumber,
  salePriceNumber,
  hasPrice,
  hasSale,
  formatMoneyData,
}: PriceSectionProps) => {
  return (
    <Box className="info-price">
      <div className="name-detail ">{capitalizeWords(String(productName))}</div>

      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        <div>
          <span className="title-price res-title">Regular price: </span>
          <span
            className="price-detail res-title"
            style={{
              textDecoration: hasSale ? "line-through" : "none",
              color: hasSale ? "#50555c" : "#007F18",
              fontWeight: 700,
            }}>
            {hasPrice ? formatMoneyData(regularPriceNumber) : "CALL"}
          </span>
        </div>

        {hasSale && (
          <div>
            <span className="title-price res-title">On sale price: </span>
            <span
              className="price-detail res-title"
              style={{
                color: "#007F18",
                fontWeight: 800,
                fontSize: "20px",
              }}>
              {formatMoneyData(salePriceNumber)}
            </span>
          </div>
        )}
      </div>
    </Box>
  );
};

export default PriceSection;
